import React from 'react';
import css from './drawer.module.css';

interface DrawerProps {
  children: React.ReactNode;
  isOpen: boolean;
}

const Drawer = ({ children, isOpen }: DrawerProps) => {
  return (
    <div className={`${css.drawer} ${isOpen ? css.open : ''}`}>
      <div className={css['drawer-container']}>{children}</div>
    </div>
  );
};

export default Drawer;
